import { gatewayPhone } from "../../../../gateways/gatewayPhone";
import { SmsMessage } from "../chat/types/SmsMessage";

export const resendChatSms = async (uid: string): Promise<SmsMessage> => {
  if (!uid?.trim()) {
    throw new Error("Message uid is required");
  }

  const { data } = await gatewayPhone.post(`twilio/sms/resend/${uid.trim()}`);

  return data;
};
